import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomMyqoutesComponent } from 'src/app/modules/custom-landing/custom-myqoutes/custom-myqoutes.component';
import { ITBEditConfirmBidComponent } from '../itb-edit-confirm-bid/itb-edit-confirm-bid.component';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AllowNegativeDecimalNumber, CopyDirective } from '../two-digit-decima-number.directive';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-itb-edit-bid',
    templateUrl: './itb-edit-bid.component.html',
    styleUrls: ['./itb-edit-bid.component.scss'],
    imports: [NgIf, FormsModule, NgFor, AllowNegativeDecimalNumber, CopyDirective, DecimalPipe, DatePipe, I18nModule]
})
export class ITBEditBidComponent implements OnInit {
  activeTab = 'none';
  priceTab = 'none';
  @Input() productsInfo: any;
  @Input() priceshw: any;
  @Input() indexPriceshw: number;
  @Input() tabName: any;
  @Input() selectProduct: any;
  @Input() productsEntry: any;
  @Input() dischargePortshw: any;
  @Input() quantityshw: any;
  priceVal: any;
  a: any;
  productInfo: any;
  COI: boolean = false;
  ITB: boolean = false;
  OpenNegotiation: boolean = true;
  PriceEmpty:boolean = false;
  displayFixedQPSection:boolean = false;
  defaultValue=null;
  constructor(public ActiveModal: NgbActiveModal, public ModalService: NgbModal, 
    private modalService: NgbModal,public customProductService:CustomProductsService) { }
  ngOnInit(): void {
    this.productInfo = this.productsInfo;
    if (this.productInfo?.combinedTenders.length == 1) {
      this.a = this.productInfo?.combinedTenders[0];
      console.log(this.a);
    } else {
      this.productInfo = this.selectProduct;
      this.a = this.productsEntry[0];
    }
    this.activeTab = this.tabName ? this.tabName : 'none';
    this.priceTab = this.tabName ? this.tabName : 'none';
  }
  checkPriceValidation($event) {
    if (this.productInfo.commodityType == 'CN') {
      const priceVal = $event.target.value;
      const m = priceVal.match(/\d+/g);
      this.priceshw = m === null ? '-' : `-${m}`;
    }
  }
  qpChangeAction(event:any,index,options){
    console.log(event);
    options.pricingOptionsEnum[0].qp=[];
    if(event.target.value === 'Fixed QP'){
     
      this.displayFixedQPSection = true;
    }else{
     
      this.displayFixedQPSection = false;
    }
    let valueSelected = options.pricingOptionsEnum[0].qpMultipleChoices.find(x=>x.description == event.target.value);
    
    options.pricingOptionsEnum[0].qp.push(valueSelected);
  }
  changeTab(data): any {
    this.activeTab = data;
    if (this.activeTab === 'fixedprice') {
      this.priceTab = 'fixedprice'
    }
    else if (this.activeTab === 'indexprice') {
      this.priceTab = 'indexprice'
    }
  }
  close(): any {
    this.ActiveModal.close();
  }
  divide() {
    if(this.a?.childList == undefined){
      if(!isNaN(this.priceshw)){
        //this.priceshw = Math.abs(this.priceshw)
        this.indexPriceshw= (this.priceshw/ 1000);
        this.indexPriceshw = Number(this.indexPriceshw.toFixed(5));
      }
      else{
        this.priceshw = null;
        this.indexPriceshw = null;
      }
    }
    else if(this.a?.childList?.length>0){
      this.a.childList.forEach(element => {
        element.indexPriceshw = (element.priceshw/1000);
      });

    }
    
  }
  checkpriceEnteredorNot(){
    if(this.priceshw == '' || this.priceshw == 0 || this.priceshw == undefined){
      this.PriceEmpty = true;
    }
    else{
      this.PriceEmpty = false;
    }
    return this.PriceEmpty;
  }
  Openmodal() {
    let proceedFurther:boolean = this.checkpriceEnteredorNot();
      if(!proceedFurther){
        const ModalRef = this.modalService.open(ITBEditConfirmBidComponent, { centered: true, size: 'sm' });
        if (this.productInfo?.combinedTenders.length == 1) {
          ModalRef.componentInstance.datePeriod = this.productInfo;
          ModalRef.componentInstance.code = this.productInfo?.combinedTenders[0];
          ModalRef.componentInstance.priceshw = this.priceshw;
          ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
          ModalRef.componentInstance.quantityshw = this.quantityshw;
          ModalRef.componentInstance.indexPriceshw = this.productInfo?.combinedTenders[0].displayRCPriceConfig.displayRCPrice == true ? this.indexPriceshw : null;
        } else {
          ModalRef.componentInstance.datePeriod = this.selectProduct;
          ModalRef.componentInstance.code = this.productsEntry;
          ModalRef.componentInstance.priceshw = this.priceshw;
          ModalRef.componentInstance.indexPriceshw = this.productInfo?.combinedTenders[0].displayRCPriceConfig.displayRCPrice == true ? this.indexPriceshw : null;
        }
    
        // if(this.productsInfo.quoteEntries[0].pricingOptionsEnum[0].pricingOptions=='FIXED'){
        //   ModalRef.componentInstance.price=this.price;
        // }
        //  if(this.productsInfo.quoteEntries[0].pricingOptionsEnum[0].pricingOptions=='INDEX'){
        //   ModalRef.componentInstance.price=this.indexPrice;
        //  }
        this.ActiveModal.close();
      }
    
  }
  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 46 || (k >= 48 && k <= 57));
  }
  getDate(date) {
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }
    

  }
  formatQPDates(data){
    return this.customProductService.formatQPDates(data);
  }
}
